module.exports = __webpack_public_path__ + "static/a-xx-006-art-e17f61bdb85f974116fa978cd2b273aa.jpg";